import {paymentStatusTypes} from 'app/constant'
import HistoryItem from 'app/features/orders/componentsv1/shared/orderHistory/HistoryItem'
import OrderHistory from 'app/features/orders/componentsv1/shared/orderHistory/OrderHistory'
import {ViewOrder} from 'app/features/orders/models/OrderState'
import {
  selectViewOrder,
  selectViewOrderCreatedAt,
  selectViewOrderCreatedBy,
  selectViewOrderCustomer,
  selectViewOrderHistory,
  selectViewOrderIsLoginOrder,
  selectViewOrderNumber,
} from 'app/features/orders/redux/order/orderSlice'
import {useSelector} from 'react-redux'
import {RootState} from 'setup'

export const OrderHistoryWrapper = () => {
  const history = useSelector<RootState, any[]>(selectViewOrderHistory)
  const createdAt = useSelector<RootState, string>(selectViewOrderCreatedAt)
  const orderNumber = useSelector<RootState, string | any>(selectViewOrderNumber)
  const viewOrder = useSelector<RootState, ViewOrder>(selectViewOrder)
  const user = useSelector<RootState, string>(selectViewOrderCreatedBy)
  const viewCustomer = useSelector<RootState, any>(selectViewOrderCustomer)
  const isLoginOrder = useSelector<RootState, boolean>(selectViewOrderIsLoginOrder)

  return (
    <OrderHistory history={history} orderNumber={orderNumber}>
      {viewOrder.financialStatus !== paymentStatusTypes.failed &&
        viewOrder.financialStatus !== paymentStatusTypes.pending && (
          <HistoryItem
            title={`Order Placed ${
              viewOrder.orderType === 'E_COMMERCE'
                ? viewCustomer?.id
                  ? isLoginOrder
                    ? '- Logged In'
                    : '- Guest'
                  : '- Guest'
                : ''
            }`}
            createdAt={createdAt}
            isLast
            user={user}
            userLabel='Created By'
          />
        )}
    </OrderHistory>
  )
}

export default OrderHistoryWrapper
